/** Configuration → Workflow — modules, record types, statuses, triggers, sample rules */

export const WF_MODULE_OPTIONS = [
  { value: 'customers', label: 'Customer' },
  { value: 'businesses', label: 'Business' },
  { value: 'support_tickets', label: 'Support Tickets' },
  { value: 'appeals', label: 'Appeals' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'posts', label: 'Posts' },
  { value: 'quotes', label: 'Quotes' },
  { value: 'messages', label: 'Messages' },
  { value: 'reviews', label: 'Reviews' },
  { value: 'moderation', label: 'Moderation' },
  { value: 'fraud_security', label: 'Fraud & Security' },
  { value: 'billing_subscriptions', label: 'Billing & Subscriptions' },
  { value: 'teams_permissions', label: 'Teams & Permissions' },
];

export const WF_RECORD_TYPES_BY_MODULE = {
  customers: [
    { value: 'customer_account', label: 'Customer Account' },
    { value: 'customer_verification_record', label: 'Customer Verification Record' },
  ],
  businesses: [
    { value: 'business_account', label: 'Business Account' },
    { value: 'business_verification_record', label: 'Business Verification Record' },
  ],
  support_tickets: [{ value: 'ticket', label: 'Support Ticket' }],
  appeals: [{ value: 'appeal', label: 'Appeal' }],
  compliance: [
    { value: 'licence_record', label: 'Licence Record' },
    { value: 'badge_record', label: 'Badge Record' },
    { value: 'trade_ticket_record', label: 'Ticket Record' },
    { value: 'appeal_case', label: 'Appeal Case' },
  ],
  posts: [{ value: 'post', label: 'Post' }],
  quotes: [{ value: 'quote_request', label: 'Quote Request' }],
  messages: [{ value: 'message_thread', label: 'Message Thread' }],
  reviews: [{ value: 'review', label: 'Review' }],
  moderation: [
    { value: 'moderation_case', label: 'Moderation Case' },
    { value: 'appeal_case', label: 'Appeal Case' },
  ],
  fraud_security: [
    { value: 'case', label: 'Case' },
    { value: 'restriction_record', label: 'Restriction Record' },
    { value: 'appeal_case', label: 'Appeal Case' },
  ],
  billing_subscriptions: [{ value: 'subscription', label: 'Subscription' }],
  teams_permissions: [
    { value: 'team_member', label: 'Team Member' },
    { value: 'permission_record', label: 'Permission Record' },
  ],
};

/** Approved status models by record type */
export const WF_STATUSES_BY_RECORD_TYPE = {
  customer_account: [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'restricted', label: 'Restricted' },
    { value: 'banned', label: 'Banned' },
    { value: 'closed', label: 'Closed' },
  ],
  business_account: [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'restricted', label: 'Restricted' },
    { value: 'banned', label: 'Banned' },
    { value: 'closed', label: 'Closed' },
  ],
  customer_verification_record: [
    { value: 'pending', label: 'Pending' },
    { value: 'verified', label: 'Verified' },
  ],
  business_verification_record: [
    { value: 'pending', label: 'Pending' },
    { value: 'verified', label: 'Verified' },
  ],
  ticket: [
    { value: 'new', label: 'New' },
    { value: 'open', label: 'Open' },
    { value: 'waiting_on_customer', label: 'Waiting on Customer' },
    { value: 'waiting_on_business', label: 'Waiting on Business' },
    { value: 'waiting_on_visitor', label: 'Waiting on Visitor' },
    { value: 'waiting_on_support', label: 'Waiting on Support' },
    { value: 'awaiting_reply', label: 'Awaiting Reply' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'closed', label: 'Closed' },
  ],
  licence_record: [
    { value: 'new', label: 'New' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'awaiting_information', label: 'Awaiting Information' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'expired', label: 'Expired' },
    { value: 'closed', label: 'Closed' },
  ],
  badge_record: [
    { value: 'new', label: 'New' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'awaiting_information', label: 'Awaiting Information' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'expired', label: 'Expired' },
    { value: 'closed', label: 'Closed' },
  ],
  trade_ticket_record: [
    { value: 'new', label: 'New' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'awaiting_information', label: 'Awaiting Information' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'expired', label: 'Expired' },
    { value: 'closed', label: 'Closed' },
  ],
  post: [
    { value: 'draft', label: 'Draft' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'closed', label: 'Closed' },
  ],
  quote_request: [
    { value: 'new', label: 'New' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'open', label: 'Open' },
    { value: 'closed', label: 'Closed' },
    { value: 'cancelled', label: 'Cancelled' },
  ],
  message_thread: [
    { value: 'new', label: 'New' },
    { value: 'open', label: 'Open' },
    { value: 'held', label: 'Held' },
    { value: 'restricted', label: 'Restricted' },
    { value: 'closed', label: 'Closed' },
  ],
  review: [
    { value: 'new', label: 'New' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'closed', label: 'Closed' },
  ],
  case: [
    { value: 'new', label: 'New' },
    { value: 'in_review', label: 'In Review' },
    { value: 'awaiting_evidence', label: 'Awaiting Evidence' },
    { value: 'ready_for_decision', label: 'Ready for Decision' },
    { value: 'closed', label: 'Closed' },
  ],
  moderation_case: [
    { value: 'new', label: 'New' },
    { value: 'active', label: 'Active' },
    { value: 'decided', label: 'Decided' },
  ],
  appeal: [
    { value: 'awaiting_reply', label: 'Awaiting Reply' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'closed', label: 'Closed' },
  ],
  appeal_case: [
    { value: 'new', label: 'New' },
    { value: 'in_review', label: 'In Review' },
    { value: 'awaiting_evidence', label: 'Awaiting Evidence' },
    { value: 'ready_for_decision', label: 'Ready for Decision' },
    { value: 'closed', label: 'Closed' },
  ],
  restriction_record: [
    { value: 'new', label: 'New' },
    { value: 'active', label: 'Active' },
    { value: 'lifted', label: 'Lifted' },
    { value: 'escalated', label: 'Escalated' },
    { value: 'closed', label: 'Closed' },
  ],
  subscription: [
    { value: 'trial', label: 'Trial' },
    { value: 'active', label: 'Active' },
    { value: 'grace_period', label: 'Grace Period' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'ended', label: 'Ended' },
  ],
  team_member: [
    { value: 'new', label: 'New' },
    { value: 'first_login_required', label: 'First Login Required' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'removed', label: 'Removed' },
  ],
  permission_record: [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
  ],
};

/** Spec Trigger Type: Event-Based or Time-Based only. */
export const WF_TRIGGER_TYPE_OPTIONS = [
  { value: 'event_based', label: 'Event-Based' },
  { value: 'time_based', label: 'Time-Based' },
];

/** Illustrative Limits & Thresholds references — production IDs NOT CONFIRMED. */
export const WF_TIME_PERIOD_REF_OPTIONS = [
  { value: 'lth_status_change_period_60m', label: 'LTH-0010 · Equal To 60 Minutes', displayValue: '60', unit: 'Minutes' },
];

export const WF_RETRY_LIMIT_REF_OPTIONS = [
  { value: 'lth_status_change_retry_limit_1', label: 'LTH-0011 · At Most 1 Count', displayValue: '1', unit: 'Count' },
  { value: 'lth_status_change_retry_limit_0', label: 'LTH-0015 · At Most 0 Count', displayValue: '0', unit: 'Count' },
];

export const WF_RETRY_INTERVAL_REF_OPTIONS = [
  { value: 'lth_status_change_retry_interval_5m', label: 'LTH-0012 · Equal To 5 Minutes', displayValue: '5', unit: 'Minutes' },
];

/** Legacy movement timing labels retained for older rows until Time Period refs replace them. */
export const WF_MOVEMENT_TIMING_OPTIONS = [
  { value: 'immediately', label: 'Immediately' },
  { value: 'at_configured_time', label: 'At Configured Time' },
  { value: 'on_expiry_date', label: 'On Expiry Date' },
  { value: 'at_grace_period_end', label: 'At Grace Period End' },
  { value: 'after_configured_inactivity_period', label: 'After Configured Inactivity Period' },
  { value: 'after_configured_period', label: 'After Configured Period' },
];

export const WF_DEFERRED_DEFINITIONS = [
  {
    id: 'movement_trigger_catalogue',
    label: 'Complete Workflow movement, Trigger Event and timestamp catalogue',
    status: 'NOT CONFIRMED',
  },
  {
    id: 'condition_catalogue',
    label: 'Optional Workflow Condition catalogue',
    status: 'NOT DEFINED',
  },
  {
    id: 'cancellation_events',
    label: 'Additional Cancellation Event choices',
    status: 'NOT CONFIRMED',
  },
  {
    id: 'production_lth_refs',
    label: 'Production Limits & Thresholds references',
    status: 'NOT CONFIRMED',
  },
];

const LEGACY_MODULE_MAP = {
  documents: 'compliance',
  fraud_security_decision: 'fraud_security',
};

const LEGACY_RECORD_TYPE_MAP = {
  compliance_item: 'licence_record',
  document_submission: 'licence_record',
  document_record: 'licence_record',
  message: 'message_thread',
};

const LEGACY_TRIGGER_TYPE_MAP = {
  time_rule: 'time_based',
  time_event: 'time_based',
  submission_event: 'event_based',
  reply_event: 'event_based',
  manual_action: 'event_based',
  decision_event: 'event_based',
  payment_event: 'event_based',
  system_event: 'event_based',
  appeal_event: 'event_based',
  account_event: 'event_based',
};

const LEGACY_STATUS_MAP = {
  in_review: 'in_review',
  pending_evidence: 'awaiting_evidence',
  awaiting_resubmission: 'awaiting_information',
  expiry_review: 'expired',
  accepted: 'approved',
  suspended: 'ended',
  waiting_on_assigned: 'waiting_on_support',
};

const LEGACY_MOVEMENT_TIMING_MAP = {
  'After 3 calendar days': 'after_configured_period',
  Immediately: 'immediately',
};

/** Trigger conditions keyed by module|recordType|triggerType */
const WF_TRIGGER_CONDITIONS = {
  'customers|customer_verification_record|system_event': [
    'Required Verification Completed',
    'Reverification Required',
  ],
  'customers|customer_account|time_event': ['Required Verification Incomplete at Deadline'],
  'customers|customer_account|account_event': ['Account Reactivation Completed'],
  'businesses|business_verification_record|system_event': [
    'Required Verification Completed',
    'Reverification Required',
  ],
  'support_tickets|ticket|submission_event': ['Contact / Support Form Submitted'],
  'support_tickets|ticket|reply_event': [
    'Valid external reply',
    'Customer replied',
    'Business replied',
    'Visitor replied',
  ],
  'appeals|appeal|reply_event': ['Valid submitting-account reply'],
  'compliance|licence_record|submission_event': ['Licence Submission Form Submitted'],
  'compliance|licence_record|decision_event': ['More Information Requested'],
  'compliance|appeal_case|appeal_event': ['Appeal Review Started'],
  'billing_subscriptions|subscription|payment_event': ['Payment Failed'],
  'billing_subscriptions|subscription|time_event': ['Payment Not Recovered'],
  'fraud_security|restriction_record|decision_event': [
    'Release Approved',
    'Restriction Applied',
    'Escalation Approved',
  ],
  'moderation|moderation_case|manual_action': ['Case opened', 'Evidence required'],
  'moderation|moderation_case|decision_event': ['Decision recorded'],
  'moderation|case|manual_action': ['Case opened', 'Evidence required'],
  'moderation|case|decision_event': ['Decision recorded'],
  'moderation|appeal_case|appeal_event': ['Appeal Review Started'],
  'fraud_security|case|manual_action': ['Case opened', 'Evidence required'],
  'fraud_security|appeal_case|appeal_event': ['Appeal Review Started'],
  'posts|post|submission_event': ['Post submitted'],
  'quotes|quote_request|submission_event': ['Quote request submitted'],
  'messages|message_thread|reply_event': ['Reply received'],
  'reviews|review|submission_event': ['Review submitted'],
  'teams_permissions|team_member|manual_action': ['Team member added'],
  'teams_permissions|permission_record|manual_action': ['Permission updated'],
};

export function normalizeWorkflowModule(value) {
  if (!value) return '';
  return LEGACY_MODULE_MAP[value] || value;
}

export function normalizeWorkflowRecordType(value) {
  if (!value) return '';
  return LEGACY_RECORD_TYPE_MAP[value] || value;
}

export function normalizeWorkflowTriggerType(value) {
  if (!value) return '';
  return LEGACY_TRIGGER_TYPE_MAP[value] || value;
}

export function normalizeWorkflowStatus(value) {
  if (!value) return '';
  return LEGACY_STATUS_MAP[value] || value;
}

export function normalizeWorkflowMovementTiming(value) {
  if (!value) return '';
  const v = String(value || '').trim();
  if (WF_MOVEMENT_TIMING_OPTIONS.some((o) => o.value === v)) return v;
  return LEGACY_MOVEMENT_TIMING_MAP[v] || v;
}

export function normalizeWorkflowRuleScope(module, recordType) {
  return {
    module: normalizeWorkflowModule(module),
    recordType: normalizeWorkflowRecordType(recordType),
  };
}

export function getStatusesForRecordType(recordType) {
  const rt = normalizeWorkflowRecordType(recordType);
  return WF_STATUSES_BY_RECORD_TYPE[rt] || [];
}

export function getAllowedNextStatuses(recordType, currentStatus) {
  const statuses = getStatusesForRecordType(recordType);
  const cur = normalizeWorkflowStatus(currentStatus);
  if (!cur) return statuses;
  return statuses.filter((s) => s.value !== cur);
}

const LEGACY_EVENT_TRIGGER_TYPES = [
  'submission_event',
  'reply_event',
  'manual_action',
  'decision_event',
  'payment_event',
  'system_event',
  'appeal_event',
  'account_event',
];

const LEGACY_TIME_TRIGGER_TYPES = ['time_event', 'time_rule'];

function collectTriggerLabels(module, recordType, legacyTypes) {
  const mod = normalizeWorkflowModule(module);
  const rt = normalizeWorkflowRecordType(recordType);
  const seen = new Set();
  const labels = [];
  legacyTypes.forEach((legacyType) => {
    const key = `${mod}|${rt}|${legacyType}`;
    (WF_TRIGGER_CONDITIONS[key] || []).forEach((label) => {
      if (seen.has(label)) return;
      seen.add(label);
      labels.push(label);
    });
  });
  return labels.map((label) => ({ value: label, label }));
}

/** Event-Based Trigger Event choices for the selected scope. */
export function getTriggerEvents(module, recordType) {
  return collectTriggerLabels(module, recordType, LEGACY_EVENT_TRIGGER_TYPES);
}

/** Time-Based Time Starts From choices for the selected scope. */
export function getTimeStartsFromOptions(module, recordType) {
  return collectTriggerLabels(module, recordType, LEGACY_TIME_TRIGGER_TYPES);
}

/**
 * Trigger Event (Event-Based) or Time Starts From (Time-Based) options.
 * Accepts legacy trigger types via normalizeWorkflowTriggerType.
 */
export function getTriggerConditions(module, recordType, triggerType) {
  const tt = normalizeWorkflowTriggerType(triggerType);
  if (tt === 'time_based') return getTimeStartsFromOptions(module, recordType);
  if (tt === 'event_based') return getTriggerEvents(module, recordType);
  return [];
}

export function getTimePeriodRefOption(value) {
  return WF_TIME_PERIOD_REF_OPTIONS.find((o) => o.value === value) || null;
}

export function getRetryLimitRefOption(value) {
  return WF_RETRY_LIMIT_REF_OPTIONS.find((o) => o.value === value) || null;
}

export function getRetryIntervalRefOption(value) {
  return WF_RETRY_INTERVAL_REF_OPTIONS.find((o) => o.value === value) || null;
}

export function labelTimePeriodRef(value) {
  const opt = getTimePeriodRefOption(value);
  if (!opt) return value ? `${value} (Unavailable)` : '—';
  return `${opt.label}`;
}

export function labelRetryLimitRef(value) {
  const opt = getRetryLimitRefOption(value);
  if (!opt) return value ? `${value} (Unavailable)` : '—';
  return opt.label;
}

export function labelRetryIntervalRef(value) {
  const opt = getRetryIntervalRefOption(value);
  if (!opt) return value ? `${value} (Unavailable)` : '—';
  return opt.label;
}

export function getRetryLimitNumericValue(refValue) {
  const opt = getRetryLimitRefOption(refValue);
  if (!opt) return null;
  const n = Number(opt.displayValue);
  return Number.isFinite(n) ? n : null;
}

export function formatWorkflowTriggerDisplay(rule) {
  const tt = normalizeWorkflowTriggerType(rule?.triggerType);
  const eventOrStamp =
    tt === 'time_based'
      ? rule?.timeStartsFrom || rule?.triggerEvent || rule?.triggerCondition || '—'
      : rule?.triggerEvent || rule?.triggerCondition || '—';
  if (tt === 'time_based') {
    const periodRef = rule?.timePeriodRef;
    const periodOpt = getTimePeriodRefOption(periodRef);
    if (periodOpt) {
      return `Time-Based · ${eventOrStamp} · ${periodOpt.displayValue} ${periodOpt.unit}`;
    }
    if (rule?.movementTiming) {
      const timing = labelMovementTiming(rule.movementTiming);
      return `Time-Based · ${eventOrStamp}${timing && timing !== '—' ? ` · ${timing}` : ''}`;
    }
    return `Time-Based · ${eventOrStamp}`;
  }
  return `Event-Based · ${eventOrStamp}`;
}

export function formatWorkflowConditionsDisplay(rule) {
  const conditions = Array.isArray(rule?.conditions) ? rule.conditions : [];
  if (!conditions.length) return 'No Conditions';
  if (conditions.length === 1) {
    const c = conditions[0];
    const field = c.fieldLabel || c.field || c.name || 'Condition';
    const op = c.operatorLabel || c.operator || '';
    const val = c.valueLabel || c.value || (Array.isArray(c.values) ? c.values.join(', ') : '');
    return [field, op, val].filter(Boolean).join(' · ') || '1 Condition';
  }
  return `${conditions.length} Conditions`;
}

export function formatWorkflowDateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  const day = date.getDate();
  const month = date.toLocaleString('en-GB', { month: 'short' });
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const suffix = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;
  return `${day} ${month} ${year}, ${hours}:${minutes} ${suffix}`;
}

export function sortWorkflowRules(list) {
  return [...(list || [])].sort((a, b) => {
    const aTime = new Date(a.lastUpdated || a.modifiedOn || a.dateAdded || a.createdOn || 0).getTime();
    const bTime = new Date(b.lastUpdated || b.modifiedOn || b.dateAdded || b.createdOn || 0).getTime();
    return bTime - aTime;
  });
}

export function nextWorkflowRuleId(rules = []) {
  const nums = rules.map((r) => {
    const m = String(r.id || '').match(/^WF-(\d+)$/i);
    return m ? parseInt(m[1], 10) : 0;
  });
  const max = nums.length ? Math.max(...nums) : 0;
  return `WF-${String(max + 1).padStart(4, '0')}`;
}

export const WF_ROUTE = '/admin/configuration/workflow';

/** Optional Condition catalogue is NOT DEFINED — no inventable fields. */
export function getAvailableWorkflowConditionFields() {
  return [];
}

export function createEmptyWorkflowCondition() {
  return { field: '', operator: '', value: '', values: [] };
}

export function createEmptyWorkflowForm() {
  return {
    id: '',
    ruleName: '',
    description: '',
    module: '',
    recordType: '',
    currentStatus: '',
    nextStatus: '',
    triggerType: '',
    triggerEvent: '',
    triggerCondition: '',
    timeStartsFrom: '',
    timePeriodRef: '',
    movementTiming: '',
    cancellationEvents: [],
    retryLimitRef: '',
    retryIntervalRef: '',
    retryLimit: '',
    retryInterval: '',
    conditions: [],
    changeReason: '',
    dateAdded: '',
    addedBy: '',
    lastUpdated: '',
    lastUpdatedBy: '',
    createdOn: '',
    createdBy: '',
    modifiedOn: '',
    modifiedBy: '',
    version: 1,
    pendingDraft: null,
    configurationHistory: [],
    testHistory: [],
  };
}

export function normalizeWorkflowForm(raw = {}) {
  const scope = normalizeWorkflowRuleScope(raw.module, raw.recordType);
  const triggerType = normalizeWorkflowTriggerType(raw.triggerType);
  const isTime = triggerType === 'time_based';
  const triggerEvent = isTime
    ? ''
    : String(raw.triggerEvent || raw.triggerCondition || '').trim();
  const timeStartsFrom = isTime
    ? String(raw.timeStartsFrom || raw.triggerEvent || raw.triggerCondition || '').trim()
    : '';
  const retryLimitRef = raw.retryLimitRef || '';
  const retryLimitValue = getRetryLimitNumericValue(retryLimitRef);
  const retryIntervalRef =
    retryLimitValue != null && retryLimitValue > 0 ? raw.retryIntervalRef || '' : '';

  return {
    ...createEmptyWorkflowForm(),
    ...raw,
    module: scope.module,
    recordType: scope.recordType,
    currentStatus: normalizeWorkflowStatus(raw.currentStatus),
    nextStatus: normalizeWorkflowStatus(raw.nextStatus),
    triggerType,
    triggerEvent,
    triggerCondition: isTime ? timeStartsFrom : triggerEvent,
    timeStartsFrom,
    timePeriodRef: isTime ? raw.timePeriodRef || '' : '',
    movementTiming: isTime
      ? normalizeWorkflowMovementTiming(raw.movementTiming || '')
      : '',
    cancellationEvents: Array.isArray(raw.cancellationEvents)
      ? raw.cancellationEvents.filter(Boolean)
      : [],
    retryLimitRef,
    retryIntervalRef,
    conditions: Array.isArray(raw.conditions) ? raw.conditions : [],
    description: raw.description || '',
    changeReason: raw.changeReason || '',
    dateAdded: raw.dateAdded || raw.createdOn || '',
    addedBy: raw.addedBy || raw.createdBy || '',
    lastUpdated: raw.lastUpdated || raw.modifiedOn || '',
    lastUpdatedBy: raw.lastUpdatedBy || raw.modifiedBy || '',
  };
}

export function labelFromOptions(options, value) {
  if (value == null || value === '') return '';
  return options.find((o) => o.value === value)?.label ?? String(value);
}

export function getWorkflowModuleLabel(value) {
  return labelFromOptions(WF_MODULE_OPTIONS, normalizeWorkflowModule(value));
}

export function getRecordTypeLabel(module, recordTypeValue) {
  const mod = normalizeWorkflowModule(module);
  const rt = normalizeWorkflowRecordType(recordTypeValue);
  const list = WF_RECORD_TYPES_BY_MODULE[mod] || [];
  return labelFromOptions(list, rt);
}

export function getStatusLabel(recordType, statusValue) {
  const list = getStatusesForRecordType(recordType);
  return labelFromOptions(list, normalizeWorkflowStatus(statusValue));
}

export function labelMovementTiming(value) {
  const normalized = normalizeWorkflowMovementTiming(value);
  return labelFromOptions(WF_MOVEMENT_TIMING_OPTIONS, normalized) || normalized || '—';
}

function conditionSetKey(conditions = []) {
  if (!Array.isArray(conditions) || !conditions.length) return 'no_conditions';
  return [...conditions]
    .map((c) => {
      const field = String(c.field || c.name || '').trim().toLowerCase();
      const op = String(c.operator || '').trim().toLowerCase();
      const val = Array.isArray(c.values)
        ? [...c.values].map((v) => String(v).trim().toLowerCase()).sort().join(',')
        : String(c.value || '').trim().toLowerCase();
      return `${field}|${op}|${val}`;
    })
    .sort()
    .join('||');
}

function cancellationSetKey(events = []) {
  if (!Array.isArray(events) || !events.length) return 'none';
  return [...events].map((e) => String(e).trim().toLowerCase()).sort().join('|');
}

function triggerPointKey(rule) {
  const mod = normalizeWorkflowModule(rule.module);
  const rt = normalizeWorkflowRecordType(rule.recordType);
  const cur = normalizeWorkflowStatus(rule.currentStatus);
  const tt = normalizeWorkflowTriggerType(rule.triggerType);
  if (tt === 'time_based') {
    const stamp = String(rule.timeStartsFrom || rule.triggerEvent || rule.triggerCondition || '')
      .trim()
      .toLowerCase();
    const period = String(rule.timePeriodRef || normalizeWorkflowMovementTiming(rule.movementTiming) || '')
      .trim()
      .toLowerCase();
    return `${mod}|${rt}|${cur}|time_based|${stamp}|${period}`;
  }
  const event = String(rule.triggerEvent || rule.triggerCondition || '')
    .trim()
    .toLowerCase();
  return `${mod}|${rt}|${cur}|event_based|${event}`;
}

/** Exact duplicate: same scope, movement, trigger, conditions, cancellation and retry refs. */
export function workflowRuleDuplicateKey(rule) {
  const mod = normalizeWorkflowModule(rule.module);
  const rt = normalizeWorkflowRecordType(rule.recordType);
  const cur = normalizeWorkflowStatus(rule.currentStatus);
  const next = normalizeWorkflowStatus(rule.nextStatus);
  const tt = normalizeWorkflowTriggerType(rule.triggerType);
  const eventOrStamp = String(
    tt === 'time_based'
      ? rule.timeStartsFrom || rule.triggerEvent || rule.triggerCondition || ''
      : rule.triggerEvent || rule.triggerCondition || '',
  )
    .trim()
    .toLowerCase();
  const period = String(rule.timePeriodRef || normalizeWorkflowMovementTiming(rule.movementTiming) || '')
    .trim()
    .toLowerCase();
  const retryLimit = String(rule.retryLimitRef || rule.retryLimit || '').trim().toLowerCase();
  const retryInterval = String(rule.retryIntervalRef || rule.retryInterval || '').trim().toLowerCase();
  return [
    mod,
    rt,
    cur,
    next,
    tt,
    eventOrStamp,
    period,
    conditionSetKey(rule.conditions),
    cancellationSetKey(rule.cancellationEvents),
    retryLimit,
    retryInterval,
  ].join('|');
}

/** Same-trigger overlap group (Event-Based or Time-Based timing point). */
export function workflowRuleOverlapKey(rule) {
  return triggerPointKey(rule);
}

/** Competing movement from same Current Status (any trigger) — used with Next Status compare. */
export function workflowRuleConflictScopeKey(rule) {
  const mod = normalizeWorkflowModule(rule.module);
  const rt = normalizeWorkflowRecordType(rule.recordType);
  const cur = normalizeWorkflowStatus(rule.currentStatus);
  return `${mod}|${rt}|${cur}`;
}

export function findDuplicateWorkflowRule(rules, candidate, excludeId) {
  const key = workflowRuleDuplicateKey(candidate);
  return (rules || []).find((r) => r.id !== excludeId && workflowRuleDuplicateKey(r) === key);
}

/** Same trigger point that could qualify the same record (No Conditions covers the group). */
export function findOverlappingWorkflowRule(rules, candidate, excludeId) {
  const key = workflowRuleOverlapKey(candidate);
  const candConditions = conditionSetKey(candidate.conditions);
  return (rules || []).find((r) => {
    if (r.id === excludeId) return false;
    if (workflowRuleOverlapKey(r) !== key) return false;
    const otherConditions = conditionSetKey(r.conditions);
    if (candConditions === 'no_conditions' || otherConditions === 'no_conditions') return true;
    return candConditions === otherConditions;
  });
}

/** Different Next Status from same Current Status without proven separation. */
export function findConflictingWorkflowRule(rules, candidate, excludeId) {
  const scopeKey = workflowRuleConflictScopeKey(candidate);
  const next = normalizeWorkflowStatus(candidate.nextStatus);
  const candTrigger = triggerPointKey(candidate);
  return (rules || []).find((r) => {
    if (r.id === excludeId) return false;
    if (workflowRuleConflictScopeKey(r) !== scopeKey) return false;
    if (normalizeWorkflowStatus(r.nextStatus) === next) return false;
    // Same trigger point always conflicts when Next Status differs.
    if (triggerPointKey(r) === candTrigger) return true;
    // Different triggers: block when either side has No Conditions (cannot prove separation).
    const candNo = conditionSetKey(candidate.conditions) === 'no_conditions';
    const otherNo = conditionSetKey(r.conditions) === 'no_conditions';
    return candNo || otherNo;
  });
}

/** Detect A→B and B→A automatic cycle with no independent new trigger separation. */
export function findWorkflowStatusLoop(rules, candidate, excludeId) {
  const mod = normalizeWorkflowModule(candidate.module);
  const rt = normalizeWorkflowRecordType(candidate.recordType);
  const cur = normalizeWorkflowStatus(candidate.currentStatus);
  const next = normalizeWorkflowStatus(candidate.nextStatus);
  if (!cur || !next || cur === next) return null;
  return (rules || []).find((r) => {
    if (r.id === excludeId) return false;
    if (normalizeWorkflowModule(r.module) !== mod) return false;
    if (normalizeWorkflowRecordType(r.recordType) !== rt) return false;
    return (
      normalizeWorkflowStatus(r.currentStatus) === next &&
      normalizeWorkflowStatus(r.nextStatus) === cur
    );
  });
}

/** @deprecated use findOverlappingWorkflowRule / findConflictingWorkflowRule */
export function workflowRuleConflictKey(rule) {
  return workflowRuleOverlapKey(rule);
}

export function buildSampleWorkflowRules() {
  const defaultRetry = {
    retryLimitRef: 'lth_status_change_retry_limit_1',
    retryIntervalRef: 'lth_status_change_retry_interval_5m',
  };

  const samples = [
    {
      id: 'WF-0013',
      ruleName: 'Ticket Reply',
      description:
        'Return an Awaiting Reply ticket to In Progress after its external participant sends a valid reply.',
      module: 'support_tickets',
      recordType: 'ticket',
      currentStatus: 'awaiting_reply',
      nextStatus: 'in_progress',
      triggerType: 'event_based',
      triggerEvent: 'Valid external reply',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
      createdOn: '2026-08-20T09:00:00+10:00',
      createdBy: 'Olivia Brown',
      modifiedOn: '2026-08-20T11:15:00+10:00',
      modifiedBy: 'Olivia Brown',
    },
    {
      id: 'WF-0014',
      ruleName: 'Appeal Reply',
      description:
        'Return an Awaiting Reply appeal to Under Review after the submitting account sends a valid reply.',
      module: 'appeals',
      recordType: 'appeal',
      currentStatus: 'awaiting_reply',
      nextStatus: 'under_review',
      triggerType: 'event_based',
      triggerEvent: 'Valid submitting-account reply',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
      createdOn: '2026-08-19T10:15:00+10:00',
      createdBy: 'Olivia Brown',
      modifiedOn: '2026-08-19T15:20:00+10:00',
      modifiedBy: 'Olivia Brown',
    },
    {
      id: 'WF-0015',
      ruleName: 'Moderation Case Opened',
      description: 'Move a new moderation case to Active when the case is opened.',
      module: 'moderation',
      recordType: 'moderation_case',
      currentStatus: 'new',
      nextStatus: 'active',
      triggerType: 'event_based',
      triggerEvent: 'Case opened',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
      createdOn: '2026-08-21T09:00:00+10:00',
      createdBy: 'Olivia Brown',
      modifiedOn: '2026-08-21T09:00:00+10:00',
      modifiedBy: 'Olivia Brown',
    },
    {
      id: 'WF-0016',
      ruleName: 'Moderation Decision Recorded',
      description: 'Move an active moderation case to Decided when a decision is recorded.',
      module: 'moderation',
      recordType: 'moderation_case',
      currentStatus: 'active',
      nextStatus: 'decided',
      triggerType: 'event_based',
      triggerEvent: 'Decision recorded',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
      createdOn: '2026-08-21T09:05:00+10:00',
      createdBy: 'Olivia Brown',
      modifiedOn: '2026-08-21T09:05:00+10:00',
      modifiedBy: 'Olivia Brown',
    },
    {
      id: 'WF-0001',
      ruleName: 'Customer Verification Completed',
      description: 'Mark a verification record Verified when required verification is completed.',
      module: 'customers',
      recordType: 'customer_verification_record',
      currentStatus: 'pending',
      nextStatus: 'verified',
      triggerType: 'event_based',
      triggerEvent: 'Required Verification Completed',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0002',
      ruleName: 'Customer Verification Deadline Reached',
      description: 'Move an account to Inactive when required verification remains incomplete at the deadline.',
      module: 'customers',
      recordType: 'customer_account',
      currentStatus: 'active',
      nextStatus: 'inactive',
      triggerType: 'time_based',
      timeStartsFrom: 'Required Verification Incomplete at Deadline',
      timePeriodRef: 'lth_status_change_period_60m',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0003',
      ruleName: 'Customer Account Reactivated',
      description: 'Restore an Inactive account to Active when reactivation is completed.',
      module: 'customers',
      recordType: 'customer_account',
      currentStatus: 'inactive',
      nextStatus: 'active',
      triggerType: 'event_based',
      triggerEvent: 'Account Reactivation Completed',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0004',
      ruleName: 'Business Verification Completed',
      description: 'Mark a business verification record Verified when required verification is completed.',
      module: 'businesses',
      recordType: 'business_verification_record',
      currentStatus: 'pending',
      nextStatus: 'verified',
      triggerType: 'event_based',
      triggerEvent: 'Required Verification Completed',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0005',
      ruleName: 'Business Reverification Required',
      description: 'Return a Verified business verification record to Pending when reverification is required.',
      module: 'businesses',
      recordType: 'business_verification_record',
      currentStatus: 'verified',
      nextStatus: 'pending',
      triggerType: 'event_based',
      triggerEvent: 'Reverification Required',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0006',
      ruleName: 'Support Ticket Opened',
      description: 'Open a new support ticket when a contact or support form is submitted.',
      module: 'support_tickets',
      recordType: 'ticket',
      currentStatus: 'new',
      nextStatus: 'open',
      triggerType: 'event_based',
      triggerEvent: 'Contact / Support Form Submitted',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0007',
      ruleName: 'Licence Submitted',
      description: 'Move a new licence record to Under Review when the licence submission form is submitted.',
      module: 'compliance',
      recordType: 'licence_record',
      currentStatus: 'new',
      nextStatus: 'under_review',
      triggerType: 'event_based',
      triggerEvent: 'Licence Submission Form Submitted',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0008',
      ruleName: 'Licence Information Requested',
      description: 'Move a licence under review to Awaiting Information when more information is requested.',
      module: 'compliance',
      recordType: 'licence_record',
      currentStatus: 'under_review',
      nextStatus: 'awaiting_information',
      triggerType: 'event_based',
      triggerEvent: 'More Information Requested',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0009',
      ruleName: 'Payment Failed',
      description: 'Move an Active subscription to Grace Period when payment fails.',
      module: 'billing_subscriptions',
      recordType: 'subscription',
      currentStatus: 'active',
      nextStatus: 'grace_period',
      triggerType: 'event_based',
      triggerEvent: 'Payment Failed',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0010',
      ruleName: 'Grace Period Ended',
      description: 'End a subscription in Grace Period when payment is not recovered.',
      module: 'billing_subscriptions',
      recordType: 'subscription',
      currentStatus: 'grace_period',
      nextStatus: 'ended',
      triggerType: 'time_based',
      timeStartsFrom: 'Payment Not Recovered',
      timePeriodRef: 'lth_status_change_period_60m',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0011',
      ruleName: 'Appeal Review Started',
      description: 'Move a new compliance appeal case to In Review when appeal review starts.',
      module: 'compliance',
      recordType: 'appeal_case',
      currentStatus: 'new',
      nextStatus: 'in_review',
      triggerType: 'event_based',
      triggerEvent: 'Appeal Review Started',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
    {
      id: 'WF-0012',
      ruleName: 'Restriction Released',
      description: 'Lift an Active restriction when release is approved.',
      module: 'fraud_security',
      recordType: 'restriction_record',
      currentStatus: 'active',
      nextStatus: 'lifted',
      triggerType: 'event_based',
      triggerEvent: 'Release Approved',
      conditions: [],
      cancellationEvents: [],
      ...defaultRetry,
    },
  ];

  let undatedIndex = 0;
  return samples.map((r) => {
    const hasDates = Boolean(r.createdOn);
    const index = hasDates ? 0 : undatedIndex++;
    const day = String(20 - index).padStart(2, '0');
    const createdOn = r.createdOn || `2026-04-${day}T08:30:00+10:00`;
    const modifiedOn = r.modifiedOn || `2026-04-${day}T10:15:00+10:00`;
    const normalized = normalizeWorkflowForm({
      ...r,
      createdOn,
      createdBy: r.createdBy || 'Olivia Brown',
      modifiedOn,
      modifiedBy: r.modifiedBy || 'Olivia Brown',
      dateAdded: createdOn,
      addedBy: r.createdBy || 'Olivia Brown',
      lastUpdated: modifiedOn,
      lastUpdatedBy: r.modifiedBy || 'Olivia Brown',
    });
    return {
      ...normalized,
      version: 1,
      pendingDraft: null,
      configurationHistory: [],
      testHistory: [],
    };
  });
}

/** @deprecated use findConflictingWorkflowRule conflict + findDuplicateWorkflowRule */
export function findDirectionalConflictWorkflowRule(rules, candidate, excludeId) {
  return findConflictingWorkflowRule(rules, candidate, excludeId);
}

/** @deprecated */
export function canHaveMultipleNextStatuses() {
  return false;
}

/** @deprecated use getStatusesForRecordType */
export const WF_STATUSES_BY_MODULE = {};
